@if (initialized) {
    <div class="ei-import-table-widget flex flex-column gap-3">

        <!--
          Sticky multi-select status filter.
          ------------------------------------------------------------------
          Replaces the former <mvs-multi-select-toolbar-component>. Kept
          in-place so the shared toolbar (used in 18 other locations with
          single-select semantics) is not affected. Visual language mirrors
          the shared toolbar: p-chip per status, primary-tinted when active,
          neutral when inactive, optional icon, badge with the groupBy count.
          Sticks to the viewport top via PrimeFlex `sticky top-0 z-2`.
        -->
        <!--
          Status filter bar temporarily hidden per product decision.
          Uncomment to re-enable the sticky multi-select chip filter.
          Keep the TS-side state (selectedStatuses, toggleStatus,
          FilterCriteria.createOr composition in initImportWidget) — it
          still honours `?importStatus=X` deep-links from the Overview KPI
          tiles, so hiding the chips does not break that flow.
        -->
        <!--
        <div class="ei-import-table-widget__filter-bar sticky top-0 z-2 surface-0 py-2">
            <div class="flex flex-wrap gap-2 align-items-center p-3 surface-0 border-round shadow-1">
                <span class="text-sm font-medium text-color-secondary mr-2">Status:</span>

                &lt;!&ndash; Alle: clears every selected status &ndash;&gt;
                <p-chip
                        (click)="toggleStatus(null)"
                        class="w-max cursor-pointer p-1 border-round-sm {{
                            selectedStatuses.length === 0
                                ? 'bg-primary-100 text-primary border-left-3 border-primary-500'
                                : 'surface-100 border-1 border-300'
                        }}">
                    <span class="mx-2 w-max">Alle</span>
                    <p-badge [value]="totalCount" class="mx-1"></p-badge>
                </p-chip>

                &lt;!&ndash; One chip per status; click toggles it in/out of selectedStatuses &ndash;&gt;
                @for (status of statusEntries; track status.key) {
                    <p-chip
                            (click)="toggleStatus(status.key)"
                            class="w-max cursor-pointer p-1 border-round-sm {{
                                selectedStatuses.includes(status.key)
                                    ? 'bg-primary-100 text-primary border-left-3 border-primary-500'
                                    : 'surface-100 border-1 border-300'
                            }}">
                        <i *ngIf="status.image"
                           class="{{ status.image }} text-sm ml-1"
                           [ngClass]="status.color ? 'text-' + status.color : ''"></i>
                        <span class="mx-2 w-max">{{ status.label }}</span>
                        <p-badge [value]="status['count']" class="mx-1"></p-badge>
                    </p-chip>
                }
            </div>
        </div>
        -->


        <!-- Data table — status filter is applied inside initImportWidget() -->
        <mvs-widget class="shadow-1 block"
                *ngIf="widgetEiImports"
                [widgetData]="widgetEiImports"
                [widgetToolbarButtons]="widgetToolbarButtons"
                (onToolbarButtonClick)="handleToolbarButtonClick(op, $event)"
                (onObjectSelect)="handleObjectSelect($event)"
                (dblclick)="openImportInNewTab($event)"
        ></mvs-widget>

        <p-popover
                #op
                appendTo="body"
                (close)="selectedSchema = null;">
                <p-select
                        [options]="schemaFileList"
                        [(ngModel)]="selectedSchema"
                        optionLabel="name"
                        placeholder="Select Schema"
                        (onChange)="handleSchemaNavigation()"/>
        </p-popover>

    </div>
}